<template>
  <div class="search">
    <input
      placeholder="Поиск..."
      v-model="search"
      @input="input"
      class="form-control mb-4 search"
      aria-describedby="addon-right addon-left"
    />
  </div>
</template>
<script>
export default {
  name: "Search",
  data() {
    return {
      search: "",
    };
  },
  methods: {
    input() {
      this.$emit("input", this.search);
    },
  },
};
</script>
<style>
</style>
